import type { IconName } from '@fortawesome/fontawesome-svg-core';
import { Stack, Typography } from '@mui/material';
import React from 'react';
import { defineMessages } from 'react-intl';

import Icon from '@components/Icon/Icon';

import { useCuration } from '@hooks/useCuration';
import { useIsMobile } from '@hooks/useIsMobile';

import { formatFhirDate } from '@utils/fhir';

type Content = {
  icon: IconName;
  key: string;
  value: string;
};

const messages = defineMessages({
  lastEdit: {
    id: 'curationStats.lastEdit',
    defaultMessage: 'Last Edit',
  },
  publishedOn: {
    id: 'curationStats.publishedOn',
    defaultMessage: 'Published on',
  },
  revisions: {
    id: 'curationStats.revisions',
    defaultMessage: 'Revisions',
  },
});

export default function CurationStats() {
  const {
    state: { record },
  } = useCuration();
  const mobile = useIsMobile('md');

  const content: Content[] = [
    {
      icon: 'pencil',
      key: messages.lastEdit.defaultMessage,
      value: formatFhirDate(record?.lastUpdate, { showTime: false }) ?? '-',
    },
    {
      icon: 'calendar-check',
      key: messages.publishedOn.defaultMessage,
      value:
        formatFhirDate(record?.curationMeta?.published_on, {
          showTime: false,
        }) ?? '-',
    },
    {
      icon: 'clock-rotate-left',
      key: messages.revisions.defaultMessage,
      value: String(record?.curationMeta?.revisions ?? 0),
    },
  ];

  return (
    <Stack direction={mobile ? 'column' : 'row'} spacing={mobile ? 0 : 2}>
      {content.map(({ icon, key, value }) => (
        <Stack
          key={`${key}-${value}`}
          direction="row"
          alignItems="center"
          gap={1}
        >
          <Icon color="primary.main" name={icon} size="1x" type="fas" />
          <Typography variant="body2">
            {key}: {value}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
}
